<template>
  <div class="header wrapper" v-bind:class="{ 'box-padding' : isPC }">
    <div class="bar-press">
      <div></div>
    </div>
    <div class="col-sm-2 col-xs-4"><a @click="$router.push({name: 'index'})"><img src="../assets/img/main/logo-red.png" alt="" class="logo"></a></div>
    <div class="col-sm-8" v-if="isPC" id="page-name">

        <img v-show="pageIcon == 'service'" src="../assets/img/icon/service.png" alt="">
        <img v-show="pageIcon == 'business'" src="../assets/img/icon/business.png" alt="">
        <img v-show="pageIcon == 'about'" src="../assets/img/icon/about.png" alt="">
        <img v-show="pageIcon == 'contact'" src="../assets/img/icon/contact.png" alt="">
        <img v-show="pageIcon == 'work.list'" src="../assets/img/icon/work.list.png" alt="">
        <span v-t="activeNav"></span>
    </div>
    <div class="col-sm-2 col-xs-8 corner">
      <div class="language">
        <a @click="changeLocale('en')">EN</a>
        <span>|</span>
        <a @click="changeLocale('zh_cn')">CN</a>
      </div>
      <img src="../assets/img/icon/nav-red.png" alt="" class="nav-toggle" @click="openNav">
    </div>
    <div class="col-xs-12" v-if="!isPC" id="page-name">
      <img v-show="pageIcon == 'service'" src="../assets/img/icon/service.png" alt="">
      <img v-show="pageIcon == 'business'" src="../assets/img/icon/business.png" alt="">
      <img v-show="pageIcon == 'about'" src="../assets/img/icon/about.png" alt="">
      <img v-show="pageIcon == 'contact'" src="../assets/img/icon/contact.png" alt="">
      <img v-show="pageIcon == 'work.list'" src="../assets/img/icon/work.list.png" alt="">
      <span v-t="activeNav"></span>
    </div>
  </div>
</template>
<script>
  import hub from '../utils/hub';
  import navConfig from '../navConfig';

  export default {
    data() {
      return {
        isPC: window.isPC,
      };
    },
    computed: {
      activeNav() {
        let nav = navConfig.find((item) => item.to.name.split('.')[0] === this.$route.name.split('.')[0]);
        return nav ? nav.name : '';
      },
      pageIcon() {
        return this.$route.name;
      },
      src() {
        let st = "../assets/img/icon/" + this.$route.name + ".png";
        return st;
      }
    },
    methods: {
      openNav() {
        hub.$emit('open-nav');
      },
      changeLocale(lang) {
        this.$i18n.locale = lang;
        const { name } = this.$route;
        this.$router.push({ name, params: { lang } });
      }
    },
    mounted: {

    }
  };
</script>
<style>
  .header .corner div a {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/header.vue